<h2 *ngIf="data.title" [innerHTML]="data.title" mat-dialog-title></h2>
<mat-dialog-content *ngIf="data.content" [innerHTML]="data.content"></mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="data.callback(false)" mat-button mat-dialog-close>Fermer</button>
  <button (click)="data.callback(true)" [mat-dialog-close]="true" color="warn" mat-flat-button>Continuer</button>
</mat-dialog-actions>
